var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.418,
    height: 24.82,
    viewBox: "0 0 22.418 24.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    "data-name": "Grupo 393",
    transform: "translate(0.104 0.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    d: "M16.348,12.145V24.823a1.584,1.584,0,0,1-1.585,1.585H2.085A1.589,1.589,0,0,1,.5,24.823V12.145A1.589,1.589,0,0,1,2.085,10.56H14.763A1.584,1.584,0,0,1,16.348,12.145Z",
    transform: "translate(-0.104 -2.192)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_553",
    "data-name": "Trazado 553",
    d: "M24.611,6.143l-.04,2.377-2.052-.032.04-2.227A3.5,3.5,0,0,0,19.12,2.7a3.458,3.458,0,0,0-2.48.975,3.5,3.5,0,0,0-1.062,2.456l-.04,2.227-2.06-.032.04-2.377a5.548,5.548,0,0,1,11.094.19Z",
    transform: "translate(-2.798 -0.104)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.4d42f964d8335a3c77ae2dfa4ea56d3c.svg";
export { ForwardRef as ReactComponent };